import api from '@/api';
import type { PendingDeletion } from '@/api/billing';

export async function requestAccountDeletion(): Promise<{
  scheduledDeletionAt: number;
  undoUntil: number;
}> {
  const { data } = await api.post<{
    status: string;
    scheduledDeletionAt: number;
    undoUntil: number;
    message?: string;
  }>('/account/delete-request', {});
  if (data.status !== 'success') {
    throw new Error(data.message ?? 'Failed to request account deletion');
  }
  return { scheduledDeletionAt: data.scheduledDeletionAt, undoUntil: data.undoUntil };
}

export async function cancelAccountDeletion(): Promise<void> {
  const { data } = await api.post<{ status: string; message?: string }>('/account/delete-request', {
    cancel: true,
  });
  if (data.status !== 'success') {
    throw new Error(data.message ?? 'Failed to cancel account deletion');
  }
}

export type { PendingDeletion };
